import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

const Input = forwardRef(
  (
    {
      label,
      error,
      hint,
      className,
      wrapperClassName,
      id,
      required,
      ...props
    },
    ref
  ) => {
    const inputId = id || props.name || label?.replace(/\s/g, '-');

    return (
      <div className={cn('space-y-1.5', wrapperClassName)}>
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-gray-700"
          >
            {label}
            {required && <span className="text-red-500 ms-0.5">*</span>}
          </label>
        )}

        <input
          ref={ref}
          id={inputId}
          required={required}
          className={cn(
            'block w-full rounded-lg border px-3 py-2 text-sm transition-colors duration-150',
            'placeholder:text-gray-400',
            'focus:outline-none focus:ring-2 focus:ring-offset-0',
            error
              ? 'border-red-300 focus:border-red-500 focus:ring-red-200 bg-red-50'
              : 'border-gray-300 focus:border-primary-500 focus:ring-primary-200 bg-white',
            'disabled:bg-gray-100 disabled:cursor-not-allowed',
            className
          )}
          {...props}
        />

        {hint && !error && (
          <p className="text-xs text-gray-500">{hint}</p>
        )}

        {error && (
          <p className="text-xs text-red-600">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
